<script>
  import { tausender_trenner } from "./UtilsBalkenProgress.svelte";
  import { find_help_text_if_exists } from "./Utils.svelte";

  export let max_value;
  export let deactivated_animals = 0;
  export let deactivated_animals_from_animals_table = 0;
  export let is_total = false;

  export let helptexts;
  export let in_show_helptext_id;

  let heigth = 150;
</script>

<td style="vertical-align: top; padding: 0px;">
  <table style="padding-top:0px; margin: 0 auto;">
    <tr style="padding-top:0px;">
      <td style="padding-top:0px;">
        <div
          style="padding: 0px; text-align: center; margin: 0 auto; width: 40px; background-color: #AFC5B9; height: {deactivated_animals_from_animals_table *
            (heigth / max_value)}px;"
        />
      </td>
      {#if is_total}
        <td rowspan="3" style="padding-top:0px;">
          <div style="padding: 0px; text-align: center; margin: 0 auto; width: 40px; background-color: #FFFFFF;">
            <div
              class="breite hoverclass"
              style="margin-bottom:  5px; text-align:  center;height: 12px; color: #000000; background-color: #AFC5B9"
            >
              Decr.
              <div class="info-box-auf-hoehe">
                {#if find_help_text_if_exists(helptexts, "marketing_mirror_deactivated_2")}
                  {@html find_help_text_if_exists(helptexts, "marketing_mirror_deactivated_2")}
                {:else}
                  <p>
                    <strong>Decrease</strong> &hellip; Total number of boluses deactivated during the reporting timeframe excluding &ldquo;Bolus
                    Churn&rdquo;.
                  </p>
                  <p>This number is an indicator for the number of bolus deactivations due to bolus replacement (remounting).</p>
                {/if}
                {#if in_show_helptext_id}
                  <div style="font-size: 7px">id: marketing_mirror_deactivated_2</div>
                  <div style="font-size: 7px">
                    [this is only shown to users with the "show_helptext_id permission (per default: Ghais, Astrid, Stefan B)]
                  </div>
                {/if}
              </div>
            </div>
            <div
              class="breite hoverclass"
              style="margin-bottom:  5px; text-align:  center;height: 12px; color: #000000; background-color: #FFC000"
            >
              Churn
              <div class="info-box-auf-hoehe">
                {#if find_help_text_if_exists(helptexts, "marketing_mirror_deactivated_3")}
                  {@html find_help_text_if_exists(helptexts, "marketing_mirror_deactivated_3")}
                {:else}
                  <p>
                    <strong>Bolus churn</strong> &hellip; Total number of active boluses from customers who cancelled their subscription during
                    the reporting timeframe, immediately before the customer cancelled the contract.
                  </p>
                  <p>
                    Bolus churn therefore shows the active boluses that have been deactivated due to the cancellation of the subscription.
                  </p>
                {/if}
                {#if in_show_helptext_id}
                  <div style="font-size: 7px">id: marketing_mirror_deactivated_3</div>
                  <div style="font-size: 7px">
                    [this is only shown to users with the "show_helptext_id permission (per default: Ghais, Astrid, Stefan B)]
                  </div>
                {/if}
              </div>
            </div>
          </div>
        </td>
      {/if}
    </tr>

    <tr style="padding-top:0px;">
      <td style="padding-top:0px;">
        <div
          style="padding: 0px; text-align: center; margin: 0 auto; width: 40px; background-color: #E8AF01; height: {deactivated_animals *
            (heigth / max_value)}px;"
        />
      </td>
    </tr>

    <tr style="padding-top:0px;">
      <td style="padding-top:0px;">
        <div style="padding: 0px; text-align: center; margin: 0 auto; width: 40px; background-color: #FFFFFF; height: {12 * 2 + 10}px;">
          <div style="height:12px; color: #455F51;">-{tausender_trenner(deactivated_animals_from_animals_table)}</div>

          <div style="height:12px; color: #A47A12;">-{tausender_trenner(deactivated_animals)}</div>
        </div>
      </td>
    </tr>
  </table>
</td>

<style>
  div {
    height: 100%;
    font-size: 10px;
    overflow: hidden;
    text-overflow: auto;
    white-space: nowrap;
  }

  .info-box-auf-hoehe {
    background: #ffffff;
    border: 0.25pt solid #d9d9d9;
    color: #000000;
    font-size: 12px;
    height: auto;
    width: auto;
    margin-left: 40px;

    /*line-height: 10px;*/
    position: absolute;
    text-align: left;
    /*text-transform: uppercase;*/
    top: inherit;
    /*    left: inherit;*/
    right: 0%;
    display: none;
    padding: 20px;
    z-index: 10;
    padding-bottom: 0px;
    padding-top: 15px;
  }

  .info-box {
    background: #ffffff;
    border: 0.25pt solid #d9d9d9;
    color: #000000;
    font-size: 12px;
    height: auto;
    width: 600;

    /*line-height: 10px;*/
    position: absolute;
    text-align: left;
    /*text-transform: uppercase;*/
    top: 30px;
    left: 30px;
    display: none;
    padding: 20px;
    z-index: 10;
    padding-bottom: 0px;
    padding-top: 15px;
  }

  .info-box:hover .info-box {
    display: block;
  }

  .info-circle {
    display: flex;
    justify-content: center;
    align-items: center;
    /*background-color: #eef3f0;*/
    border: 1px solid #999999;
    height: 25px;
    border-radius: 50%;
    width: 25px;
    text-align: center;
  }

  .info-circle:hover .info-box {
    display: block;
  }

  .info-circle:hover .info-i {
    display: none;
  }

  .hoverclass:hover .info-box {
    display: block;
  }

  .hoverclass:hover .info-i {
    display: none;
  }

  .info-box-auf-hoehe:hover .info-box-auf-hoehe {
    display: block;
  }

  .info-circle:hover .info-box-auf-hoehe {
    display: block;
  }

  .hoverclass:hover .info-box-auf-hoehe {
    display: block;
  }
</style>
